import ProviderContainer from './ProviderContainer';

export default ProviderContainer;



// WEBPACK FOOTER //
// ./src/components/Provider/index.jsx